module.exports = __webpack_public_path__ + "static/media/omsz_logo_1362x492_300dpi.a3fd653d.png";